import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { ColorStore, ColorsState } from './colors.store';

@Injectable({
  providedIn: 'root',
})
export class ColorsQuery extends QueryEntity<ColorsState> {
  constructor(protected override store: ColorStore) {
    super(store);
  }
}
